export default __webpack_public_path__ + "static/media/Token Distribution.dc4afd59.png";